
import { Questions } from "./questions";

const benefitCardData = [
  {
    id: 1,
    img: "Lower-rates.svg",
    benefit: "LOWER RATES",
    info: "Creditry offers loan to customers at relatively lower rates compared to our competitors",
  },
  {
    id: 2,
    img: "quick&easy.svg",
    benefit: "QUICK & EASY",
    info: "It is easy to access our loans either via our partners or from our website or application",
  },
  {
    id: 3,
    img: "no-payment.svg",
    benefit: "NO PAYMENT PENALTY",
    info: "It is easy to access our loans either via our partners or from our website or application",
  },
  {
    id: 4,
    img: "secure-process.svg",
    benefit: "SECURE PROCESS",
    info: "Our platform is 100% secured and we guarantee safety of your personal and business data.",
  },
  {
    id: 5,
    img: "timer5mins.svg",
    benefit: "5 MINS APPLICATION",
    info: "It takes just 5 mins to make an application on the Creditry platform.",
  },
  {
    id: 6,
    img: "cardflexible-payment.svg",
    benefit: "FLEXIBLE PAYMENT",
    info: "There is flexibility in making your loan repayment from 3-6 month.",
  },
];

const faqData = [
  {
    id: 1,
    question: "  Who is this loan for?",
    answer:
      " Creditry is a financial service firm helping businesses grow. we welcome every businesses, no matter your previous credit or loan history. To get a loan offer, Get started with Creditry.",
  },
  {
    id: 2,
    question: "  Who is this loan for?",
    answer:
      " Creditry is a financial service firm helping businesses grow. we welcome every businesses, no matter your previous credit or loan history. To get a loan offer, Get started with Creditry.",
  },
  {
    id: 3,
    question: "  Who is this loan for?",
    answer:
      " Creditry is a financial service firm helping businesses grow. we welcome every businesses, no matter your previous credit or loan history. To get a loan offer, Get started with Creditry.",
  },
  {
    id: 4,
    question: "  Who is this loan for?",
    answer:
      " Creditry is a financial service firm helping businesses grow. we welcome every businesses, no matter your previous credit or loan history. To get a loan offer, Get started with Creditry.",
  },
  {
    id: 5,
    question: "  Who is this loan for?",
    answer:
      " Creditry is a financial service firm helping businesses grow. we welcome every businesses, no matter your previous credit or loan history. To get a loan offer, Get started with Creditry.",
  },
  {
    id: 6,
    question: "  Who is this loan for?",
    answer:
      " Creditry is a financial service firm helping businesses grow. we welcome every businesses, no matter your previous credit or loan history. To get a loan offer, Get started with Creditry.",
  },
];


export function MainContent() {

  return (
    <main className=" mb-10">
      {/* about us */}
      <section className=" mb-20 px-[4vw] lg:px-[8vw] md:flex md:justify-between md:mb-36 ">
        <div className=" w-fit relative ml-auto mr-auto mb-12 -translate-x-3 md:translate-x-0 md:ml-0 md:w-[50%]">
          <img src="images/AboutUs.png" alt="about-us" className=" w-full " />
          <div className=" bg-blue-100 absolute h-full w-full left-6 top-6 -z-10"></div>
        </div>
        {/* about us content */}
        <div className=" flex flex-col gap-y-4 md:w-[40%] md:h-fit md:mt-auto md:mb-auto md:gap-y-6 ">
          <h3 className=" text-blue-500 font-bold text-xs">ABOUT US</h3>
          <h2 className=" font-bold  text-xl">
            What Creditry is and Why we exist?
          </h2>
          <p className=" text-sm text-[#333333]">
            Creditry is a financial service firm helping businesses grow. we
            welcome every businesses, no matter your previous credit or loan
            history. To get a loan offer, Get started with Creditry.
          </p>
          <button className=" bg-[#8524D6] font-medium text-white h-[3rem] w-[10rem] mb-4 rounded-md block">
            Join waitlist
          </button>
        </div>
      </section>

      {/* benefits  */}
      <section className="  relative bg-[#F8F0FF] py-8 mb-20">
        {/* curved background */}
        <div className=" absolute h-[7rem] w-full bg-white rounded-[50%] -top-[3.5rem] md:h-[20rem] md:-top-[10rem] "></div>
        {/* benefits content */}
        <div className=" mt-16 flex flex-col gap-y-4 text-center md:text-left justify-center items-center mb-16 px-[4vw] lg:px-[8vw] md:flex-row md:justify-between md:mt-[12rem] ">
          <div>
            <h3 className=" text-blue-500 text-xs font-bold mb-4 ">
              OUR BENEFITS AND FEATURES
            </h3>
            <h2 className=" font-bold text-xl">Why you should Use Creditry?</h2>
          </div>
          <p className=" text-sm text-[#333333] md:w-[50%]">
            Creditry is a financial service firm helping businesses grow. we
            welcome every businesses, no matter your previous credit or loan
            history. To get a loan offer, Get started with Creditry.
          </p>
        </div>

        {/* benefits card */}
        <article className="px-[4vw]  lg:px-[8vw] md:grid  gap-y-12 md:grid-cols-3 gap-x-4  ">
          {benefitCardData.map((item) => {
            const { id, benefit, info, img } = item;
            return (
              <div
                key={id}
                className=" text-center w-full h-[15rem] ml-auto mr-auto bg-white flex flex-col justify-center items-center gap-y-4  mb-8 md:mb-0"
              >
                <div>
                  <img src={`images/icons/${img}`} alt={benefit} />
                </div>
                <h3 className=" font-bold text-sm">{benefit}</h3>
                <p className=" w-[70%] text-xs text-[#333333]">{info}</p>
              </div>
            );
          })}
        </article>
      </section>

      {/* how to apply  */}
      <section className=" px-[4vw] lg:px-[8vw] mb-[12rem] md:mb-16 md:flex md:justify-between">
        <div className=" w-fit  relative ml-auto mr-auto mb-12 -translate-x-3 md:-translate-x-6 md:mr-0 md:w-[50%] md:order-1">
          <img
            src="images/how-to-apply.png"
            alt="about-us"
            className="w-full "
          />
          <div className=" bg-blue-100 absolute h-full w-full left-6 top-6 -z-10"></div>
        </div>
        {/* how to apply content */}
        <div className=" flex flex-col gap-y-2 md:w-[40%] md:h-fit md:mt-auto md:mb-auto ">
          <h3 className=" text-blue-500 font-bold text-xs">HOW TO APPLY?</h3>
          <h2 className=" font-bold mb-4 text-xl">
            Apply for our SME loan in these simple steps
          </h2>
          <p className=" mb-4 text-[background: #333333] text-sm">
            Creditry is a financial service firm helping businesses grow. we
            welcome every businesses, no matter your previous credit or loan
            history. To get a loan offer, Get started with Creditry.
          </p>
          <div className=" grid gap-y-8">
            <div className=" flex gap-x-10  items-center">
              <p className=" min-h-[2.5rem] min-w-[2.5rem] bg-[#DEEAFF] text-center rounded-full grid place-items-center font-semibold text-[18px]">
                1
              </p>
              <p>Create an account</p>
            </div>
            <div className=" flex gap-x-10 items-center ">
              <p className=" min-h-[40px] min-w-[40px] bg-[#DEEAFF] text-center rounded-full grid place-items-center font-semibold text-[18px]">
                2
              </p>
              <p>Provide us with your documents</p>
            </div>
            <div className=" flex gap-x-10 items-center">
              <p className=" min-h-[2.5rem] min-w-[2.5rem] bg-[#DEEAFF] text-center rounded-full grid place-items-center font-semibold text-[18px]">
                3
              </p>
              <p>Apply for an amount and get disbursed</p>
            </div>
          </div>
        </div>
      </section>

      {/* partners  */}
      <section className=" mb-16">
        <div className="relative h-[80vh] md:h-[60vh] md:flex md:justify-between">
          <div className="absolute -z-10 w-full h-full md:w-[50%] -top-36 md:top-0">
            <img
              src="images/partner.png"
              alt="partner"
              className=" w-full h-full object-cover md:hidden  "
            />
            <img
              src="images/partnerBig.png"
              alt="partner"
              className=" w-full h-full object-cover hidden md:block "
            />
          </div>
          {/* green background splash */}
          <div className=" relative bg-gradient-to-b from-transparent to-[#51F5D8]  flex h-full w-full md:bg-gradient-to-r">
            <div className=" absolute bottom-0 md:right-0 md:bottom-10 flex flex-col gap-y-4 px-[4vw] md:ml-auto md:w-[52%] md:gap-y-8 md:p-0 md:pr-[8rem] ">
              <h1 className=" text-xl font-bold">Become a Partner</h1>
              <p className=" text-sm font-medium text-[#333333]">
                We are in partnership with several leading ecommerce store in
                Nigeria providing loans to over 8000 SMEs.
              </p>
              <button className=" bg-[#8524D6] font-medium text-white h-[3.5rem] w-[10rem] mb-4 rounded-md block">
                Join waitlist
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* frequently asked questions  */}
      <section className=" px-[4vw] lg:px-[8vw] md:flex md:justify-between">
        <div className=" md:w-[40%]">
          <h3 className=" text-blue-500 font-bold text-xs mb-4">
            FREQUENTLY ASKED QUESTIONS
          </h3>
          <h1 className=" text-xl font-bold mb-4">
            Answers to some questions You might have!!
          </h1>
          <div className=" hidden md:block">
            <img src="images/question-mark.png" alt="question-mark" />
          </div>
        </div>

        {/* questions */}
        <div className="md:w-[50%]">
          {faqData.map((item) => {
            return (
              <Questions key={item.id} {...item} />
            );
          })}
        </div>
      </section>
    </main>
  );
}
